import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../theme';

export function SvgFilter(props) {
  const theme = useTheme();
  const { width = '24px', height = '24px', stroke = theme.colors.primary, fill } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
        <polygon
          stroke={stroke}
          strokeWidth="2"
          fill={fill ? stroke : ''}
          points="5 6 10.3333333 12.3066667 10.3333333 16.6666667 13 18 13 12.3066667 18.3333333 6"
        />
      </g>
    </svg>
  );
}

SvgFilter.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.bool,
};
